import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppFilter } from "app/models/app-filter.model";
import { AbPortariaFuncionario } from 'app/abstract/full-pages/portaria-funcionario/portaria-funcionario.abstract';

@Injectable({ providedIn: 'root' })
export class PortariaFuncionarioService extends AbPortariaFuncionario {

  constructor(http: HttpClient) {
    super(http);
  }

  public getAllVisitantes(filter: AppFilter): Observable<any> {
    return this.get(`visitantes/all/filter/${filter.encode()}`);
  }

  public getAcessos(): Observable<any> {
    return this.get('config_portas/status');
  }

  public getFotoVisitante(id: number): Observable<Blob> {
    return this.getBlob(`visitantes/foto/${id}`);
  }

}
